import { BadgeCheck, Car, ScanSearch, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../config/business";

const ITEMS = [
  { icon: BadgeCheck, label: `Established ${BUSINESS.established}` },
  { icon: Car, label: "All Makes & Models" },
  { icon: ScanSearch, label: "Professional Diagnostics" },
  { icon: MapPin, label: "Mississauga, Ontario" },
];

export const TrustStrip = () => (
  <div className="border-y border-white/10 bg-[#111214]" data-testid="trust-strip">
    <div className="mx-auto grid max-w-7xl grid-cols-2 divide-x divide-white/10 lg:grid-cols-4">
      {ITEMS.map((item, i) => (
        <Reveal key={item.label} delay={i * 0.08} className="h-full">
          <div className="flex h-full items-center justify-center gap-3 px-4 py-6">
            <item.icon className="h-5 w-5 shrink-0 text-[#00AEEF]" strokeWidth={2} />
            <span className="font-display text-sm font-bold uppercase tracking-[0.15em] text-[#e6e7ea] sm:text-base">
              {item.label}
            </span>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);
